import {COLOR, Link, Text} from '@lookiero/aurora';
import React from 'react';
import {useNavigate} from 'react-router-native';
import {getRoute} from './ToastLink.controller';
import {Platform} from 'react-native';

const IS_NATIVE = Platform.OS === 'ios' || Platform.OS === 'android';
const IS_IOS = Platform.OS === 'ios';

type ToastLinkProps = {path: string; children: React.ReactNode};

const ToastLink: React.FC<ToastLinkProps> = ({path, children}) => {
  const navigate = useNavigate();

  return (
    <>
      {IS_NATIVE && <Text>{`\n`}</Text>}
      {IS_IOS && <Text style={{lineHeight: 0}}>{`\n`}</Text>}
      <Link color={COLOR.TEXT_LIGHT} detail level={2} onPress={() => navigate(getRoute(path))} underlined>
        {children}
      </Link>
    </>
  );
};

export {ToastLink};
